import { render, staticRenderFns } from "./profile-invoices.vue?vue&type=template&id=cde826f2&scoped=true&"
import script from "./profile-invoices.ts?vue&type=script&lang=ts&"
export * from "./profile-invoices.ts?vue&type=script&lang=ts&"
import style0 from "./profile-invoices.scss?vue&type=style&index=0&id=cde826f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cde826f2",
  null
  
)

export default component.exports